export default __webpack_public_path__ + "static/media/nextIcon.dbea9c97.svg";